import * as React from "react"
import HeroSection from "../components/Global/HeroSection"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { graphql } from "gatsby"
import CoursesCart from "../components/Cart/Courses"

import "../components/bootstrap.min.css"
import "../components/layout.css"

const ServicesPage = ({ data }) => (
  <Layout>
    <Seo title="Services" />
    <HeroSection
      img={data.img.childImageSharp.fluid}
      title="our services"
      subtitle=""
      heroclass="services-background"
      page="/services"
    />
    <CoursesCart courses={data.courses} />
  </Layout>
)
export const query = graphql`
  {
    img: file(relativePath: { eq: "about.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    courses: allContentfulCourses {
      edges {
        node {
          id
          title
          price
          category
          description {
            description
          }
          image {
            fixed(width: 200, height: 120) {
              ...GatsbyContentfulFixed_tracedSVG
            }
          }
        }
      }
    }
  }
`
export default ServicesPage
